import React from "react";

import {
  Tooltip
} from "AWS-UI-Components-React";

const setFromLocalStorage = (id) => {
    if (localStorage.getItem("table-column-preferences")) {
      return JSON.parse(localStorage.getItem("table-column-preferences")).includes(id);
    } else {
      return defaultTableOptions.includes(id);
    }
  };

const defaultTableOptions = ["testBody"];

export const navigationItems = [
    { type: "link", text: "Create Test Case", href: "/create-test-case" },
    { type: "divider" },
    { type: "link", text: "Search Test Cases", href: "/search-test-cases" },
    { type: "divider" }
];

export const paths = {
    home: "/",
    testCases: "/create-test-case",
    searchTestCases: "/search-test-cases"
};

export const truncate = (item) => {
    return item.length < 150
        ? <span>{item}</span>
        : <span>
        <Tooltip
            text={item}
            trigger={
            <div>
                {item.substring(0, 150)}<span className="awsui-util-status-info"> ...</span>
            </div>}
        ></Tooltip>
        </span>;
};

export const testCaseTableOptions = [{
    label: "Test Case Fields",
    options: [
      {
        id: "testSuite",
        label: "Test Suite",
        visible: setFromLocalStorage("testSuite")
      },
      {
        id: "testName",
        label: "Test Name",
        visible: setFromLocalStorage("testName")
      },
      {
        id: "timestamp",
        label: "Version ID",
        visible: setFromLocalStorage("timestamp")
      },
      {
        id: "testBody",
        label: "Test Body",
        visible: setFromLocalStorage("testBody")
      }
    ]
  }];

  export const searchParamsMapForDisplay = {
    "technicalOwner": "Technical Owner",
    "productOwner": "Product Owner",
    "userStory": "User Story",
    "feature": "Feature",
    "tags": "Tags",
    "readinessState": "Readiness State",
    "automationState": "Automation State"
  };


// WEBPACK FOOTER //
// ./src/data/constdata.jsx